/* Gedrag op de pagina voor Frontrun (/live-bezoekers → Gedrag): hoe ver iemand
   scrolt en waar hij klikt, en of die klik iets deed. Clarity geeft dit alleen
   als dagtotaal; hier komt het per paginaweergave binnen, te koppelen aan de
   route en de checkout uit de pixel "Frontrun live".

   Alleen met analytics-toestemming (Shopify's eigen cookiebanner) en alleen bij
   een UK-tijdzone, dezelfde regel als de pixel. Nooit de waarde van een
   invoerveld: van een klik gaat alleen het element en de tekst van een knop of
   link mee.

   Wie: Shopify's uniqToken, dezelfde waarde die de pixel als event.clientId
   krijgt (gemeten 10-10-2026: hash in de hartslag en hier gelijk). Het cookie
   _shopify_y bestaat op deze winkel niet meer; Shopify zet nu het HttpOnly
   _shopify_analytics, dat JavaScript niet kan lezen. De server hasht het id
   zoals de hartslag, dus de ruwe waarde wordt nergens bewaard. */
(function () {
  var DOEL = 'https://frontrun.tristanzoethout.nl/bezoek/gedrag';
  var UK = /^Europe\/(London|Jersey|Guernsey|Isle_of_Man)$/;
  var tz = '';
  try { tz = Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) {}
  if (!UK.test(tz) || !navigator.sendBeacon) return;

  function mag() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return !!(p && p.analyticsProcessingAllowed && p.analyticsProcessingAllowed());
  }
  // De API komt pas met loadFeatures; de banner laadt hem meestal al zelf.
  try {
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
    }
  } catch (e) {}

  function wie() {
    try { return window.ShopifyAnalytics.lib.user().traits().uniqToken || ''; } catch (e) { return ''; }
  }

  var paginaId, begin, scrollMax, gemeldScroll, kliks, open;
  function nieuw() {
    paginaId = Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    begin = Date.now(); scrollMax = 0; gemeldScroll = -1; kliks = []; open = [];
  }
  nieuw();

  // Scrolldiepte: het verste punt onderaan het scherm, als % van de documenthoogte.
  var gepland = false;
  function meetScroll() {
    gepland = false;
    var h = document.documentElement.scrollHeight;
    if (!h) return;
    var pct = Math.min(100, Math.round((window.scrollY + window.innerHeight) / h * 100));
    if (pct > scrollMax) scrollMax = pct;
  }
  window.addEventListener('scroll', function () {
    if (!gepland) { gepland = true; requestAnimationFrame(meetScroll); }
  }, { passive: true });
  window.addEventListener('load', meetScroll);

  /* Dood = binnen een seconde na de klik verandert er niets in de DOM en gaat de
     pagina niet weg. ponytail: een carrousel of video die zelf de DOM wijzigt
     maakt een dode klik in die seconde levend; telt dus eerder te weinig dan te
     veel. Een lijst te negeren elementen als dat meetbaar uitmaakt.
     Veranderde de pagina in de seconde vóór de klik al uit zichzelf (animaties
     na het scrollen, gemeten 10-10-2026 op Broadcast), dan valt er niets te
     beoordelen: dood = null, niet gegokt. */
  var wijzigingen = 0, laatsteWijziging = 0;
  new MutationObserver(function () { wijzigingen++; laatsteWijziging = Date.now(); })
    .observe(document.documentElement, { childList: true, subtree: true, attributes: true, characterData: true });

  function selector(el) {
    var s = el.tagName.toLowerCase();
    if (el.id) s += '#' + el.id;
    var c = typeof el.className === 'string' ? el.className.trim().split(/\s+/).slice(0, 2) : [];
    if (c.length && c[0]) s += '.' + c.join('.');
    return s.slice(0, 80);
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest
      ? e.target.closest('a,button,summary,label,select,input,textarea,[role="button"],[data-maatwijzer-open]') || e.target
      : null;
    if (!t || !t.tagName) return;
    var invoer = /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName);
    // Tekst alleen van een knop of link; een klik op een tekstblok nam anders de hele alinea mee.
    var knop = /^(A|BUTTON|SUMMARY|LABEL)$/.test(t.tagName) || t.getAttribute('role') === 'button';
    var onrustig = Date.now() - laatsteWijziging < 1000;
    var k = {
      sel: selector(t),
      tekst: !knop ? '' : (t.innerText || t.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim().slice(0, 40),
      xPct: Math.round(e.clientX / window.innerWidth * 100),
      yPx: Math.round(e.pageY),
      tMs: Date.now() - begin,
      dood: null
    };
    var voor = wijzigingen;
    open.push(k);
    setTimeout(function () {
      // In een invoerveld klikken verandert de DOM nooit; dat is focus, geen dode klik.
      k.dood = (invoer || onrustig) ? null : wijzigingen === voor;
      var i = open.indexOf(k);
      if (i >= 0) { open.splice(i, 1); kliks.push(k); }
    }, 1000);
  }, true);

  // sendBeacon is beperkt; de server neemt hoogstens 4 kB en 50 kliks per keer.
  function stuur(laatste) {
    if (!mag()) return;
    var id = wie();
    if (!id) return;
    if (laatste) {
      // De pagina gaat weg: een klik die nog liep heeft navigatie veroorzaakt.
      open.forEach(function (k) { k.dood = false; kliks.push(k); });
      open = [];
    }
    if (!kliks.length && scrollMax === gemeldScroll && !laatste) return;
    do {
      var b = { id: id, tz: tz, pad: location.pathname, paginaId: paginaId,
                scrollMax: scrollMax, duurMs: Date.now() - begin, kliks: [] };
      while (kliks.length && b.kliks.length < 50) {
        b.kliks.push(kliks[0]);
        if (JSON.stringify(b).length > 4000) { b.kliks.pop(); break; }
        kliks.shift();
      }
      if (!navigator.sendBeacon(DOEL, JSON.stringify(b))) break;
    } while (kliks.length);
    gemeldScroll = scrollMax;
  }
  setInterval(function () { stuur(false); }, 30000);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') stuur(true);
  });
  window.addEventListener('pagehide', function () { stuur(true); });
  // Terug uit de bfcache is een nieuwe paginaweergave.
  window.addEventListener('pageshow', function (e) { if (e.persisted) nieuw(); });
})();
